import React, { useEffect, useState } from "react";
import { InlineWidget } from "react-calendly";


// Import router from next
import { useNavigate } from "react-router-dom";
// testing token
// const token = 'Bearer '+'aw2a2seyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjQ5MDgzNzgxLCJqdGkiOiJiZTZmNjU1MS1iNWYwLTQ3NWQtYjJhNS04ZGU3MDRlMDg2YWQiLCJ1c2VyX3V1aWQiOiJERUVETUJZRzVZQUJNUDdYIn0.Qj6DrIhpqQnwn8n-YpT0bixkl9TBUCtC-hn-E6t97Bs'; 

// live token
const token = 'Bearer '+'eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjI1ODE1MjAxLCJqdGkiOiI5ZjBlZTlhYy1lM2ZhLTQ1MjEtOWJjYy1mNDUxYjQ4MWQwN2YiLCJ1c2VyX3V1aWQiOiJGRERCUzVWTEhYNUJVV0JRIn0._pUHaYDAX5DhxDoGj4sV17CVRqv91p5rh3P53dleKdI'; 

function Calendly({onSchedule}) {

	const [userEmail, setUserEmail] = useState('');

	useEffect(async () => {
		window.addEventListener(
			'message',
			 (e) => {
				if (isCalendlyEvent(e)) {
					if(e.data.payload.event){
                        onSchedule(e.data.payload)
					}
				}
			}
		);

		var session_token = JSON.parse(localStorage.getItem("supabase.auth.token")) || '';
		setUserEmail(session_token ? session_token.currentSession.user.email : '');
		
	}, []);

    function isCalendlyEvent(e) {
		return e.data.event &&
			e.data.event.indexOf('calendly') === 0;
	};


	return (
            <div className="h-full">
                {/* <InlineWidget url={`https://calendly.com/gaper-career/15min?hide_gdpr_banner=1&email=${userEmail}`}
                styles={{height: "100vh"}}
                /> */}

				{/* Live Link */}
                <InlineWidget url={`https://calendly.com/gaper/manager-call?hide_gdpr_banner=1&email=${userEmail}`}
                styles={{height: "100vh"}}
                />
            </div>
)
};

export default Calendly;